import { UploadedFileModel } from '../client/SmartAssistantBackendClient';

export const fileToUploadedModel = (file: File): Promise<UploadedFileModel> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Datei konnte nicht gelesen werden.'));
        return;
      }
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(new UploadedFileModel({
        fileName: file.name,
        contentType: file.type || 'application/octet-stream',
        base64Content: base64,
      }));
    };
    reader.onerror = () => reject(reader.error ?? new Error('Datei konnte nicht gelesen werden.'));
    reader.readAsDataURL(file);
  });
};
